/**
 * @file
 * Hide/Show explanation text in Transparency Promise Modal
 */

(function ($, Drupal) {
  Drupal.behaviors.transparency_promise = {
    attach: function attach(context) {
      once('awTransparencyPromise', '.tp-modal__promise__exp', context).forEach(function(currentElement) {
        currentElement.addEventListener('click', function() {
          $(this).parent().next().toggleClass('show');
        });
      });
    }
  };
})(jQuery, Drupal);
